<template>
  <v-menu offset-y z-index="50">
    <template #activator="{ on, attrs }">
      <div v-tooltip="disabled && disabledTooltip">
        <ui-button :disabled="disabled" :variant="variant" v-bind="attrs" v-on="on">
          <template v-if="icon" #iconLeft>
            <v-icon color="black darken-3">{{ icon }}</v-icon>
          </template>
          {{ label }}
          <template #iconRight>
            <v-icon color="black darken-3" size="18">mdi-chevron-down</v-icon>
          </template>
        </ui-button>
      </div>
    </template>
    <div class="viewing-options-menu">
      <v-list class="viewing-options-list pa-0">
        <v-list-item
          v-for="option in options"
          :key="option.value"
          class="viewing-options-list-item"
          :class="{ blue50: option.value === value }"
          @click="$emit('select', option.value)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ option.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-if="note">
        <v-divider />
        <div class="viewing-options-list-note px-4 py-2 text-caption gray500--text">{{ note }}</div>
      </template>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: 'UiExportMenuButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTooltip: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'mdi-text-box-multiple-outline',
    },
    label: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'secondary',
    },
    options: {
      type: Array,
      default: () => [
        { value: 'xlsx', label: '.xlsx' },
        { value: 'csv', label: '.csv' },
      ],
    },
    value: {
      type: [String, Number],
      default: null,
    },
    note: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.viewing-options-menu {
  border-radius: 6px !important;
  overflow: hidden;
  background-color: white;
}

.viewing-options-list {
  &-item {
    min-height: 40px;
    cursor: pointer;
    .v-list-item__content {
      padding: 8px 0;
      .v-list-item__title {
        font-size: 12px;
        font-weight: 700;
        line-height: 20px;
      }
    }
  }

  &-note {
    line-height: 16px;
  }
}
</style>
